"use client"

import { Geist, Geist_Mono } from "next/font/google";
import "./globals.css";
import { useEffect, Suspense } from 'react';
import { metadata } from './metadata';
import Script from 'next/script';
import { usePathname, useSearchParams } from 'next/navigation';

const gaId = process.env.NEXT_PUBLIC_G_TAG!;

declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}

const geistSans = Geist({
  variable: "--font-geist-sans",
  subsets: ["latin"],
});

const geistMono = Geist_Mono({
  variable: "--font-geist-mono",
  subsets: ["latin"],
});

function SearchParamsHandler() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      if (typeof window.gtag === 'function') {
        window.gtag('event', 'page_view', { page_path: url });
      } else {
        console.error('gtag is not defined');
      }
    };

    // Initial page load
    // handleRouteChange(pathname + searchParams.toString());
    
    const searchParamsString = searchParams.toString();
    const url = pathname + (searchParamsString ? `?${searchParamsString}` : '');
    handleRouteChange(url);

  }, [pathname, searchParams]);

  return null;
}

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  

  useEffect(() => {
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js').then((registration) => {
          console.log('ServiceWorker registration successful with scope: ', registration.scope);
        }, (err) => {
          console.log('ServiceWorker registration failed: ', err);
        });
      });
    }
  }, [])

  

  const title = typeof metadata.title === 'string' ? metadata.title : 'Default Title';
  const description = typeof metadata.description === 'string' ? metadata.description : 'Default Description';

  let manifestFilePath = "/manifest.json"
  if(process.env.NEXT_PUBLIC_BASE_PATH == "https://infraqap.plorus.in"){
    manifestFilePath = "/manifest-test.json"
  }

  return (
    <html lang="en">
      <head>
        {/* Load GA script */}
        <Script
          src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
          strategy="afterInteractive"
        />
        {/* Initialize GA */}
        <Script id="gtag-init" strategy="afterInteractive">
          {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${gaId}', {
              page_path: window.location.pathname,
            });
          `}
        </Script>
        <link rel="manifest" href={manifestFilePath} />
        <title>{title}</title>
        <meta name="description" content={description} />
      </head>
      <body
        className={`${geistSans.variable} ${geistMono.variable} antialiased text-black`}
      >
        <div className='min-h-[100vh]'>
          <Suspense fallback={<></>}>
            <SearchParamsHandler />
          </Suspense>
          {children}
        </div>
      </body>
    </html>
  );
}